import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import LandingPage from "@/pages/LandingPage";
import DecisionInputPage from "@/pages/DecisionInputPage";
import FrameworkSelectPage from "@/pages/FrameworkSelectPage";
import ThinkingFlowPage from "@/pages/ThinkingFlowPage";
import DecisionMapPage from "@/pages/DecisionMapPage";
import SharedDecisionPage from "@/pages/SharedDecisionPage";
import HistoryPage from "@/pages/HistoryPage";
import PricingPage from "@/pages/PricingPage";
import PaymentSuccessPage from "@/pages/PaymentSuccessPage";
import AuthCallback from "@/pages/AuthCallback";
import TermsPage from "@/pages/TermsPage";
import PrivacyPage from "@/pages/PrivacyPage";
import RefundPage from "@/pages/RefundPage";
import ContactPage from "@/pages/ContactPage";
import EnterpriseDecisionPage from "@/pages/EnterpriseDecisionPage";
import EnterpriseAnalysisPage from "@/pages/EnterpriseAnalysisPage";
import EnterpriseHistoryPage from "@/pages/EnterpriseHistoryPage";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH

function AppRouter() {
  const location = useLocation();
  
  // Check URL fragment for session_id (auth callback) - must be synchronous
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }

  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/decide" element={<DecisionInputPage />} />
      <Route path="/framework/:sessionId" element={<FrameworkSelectPage />} />
      <Route path="/think/:sessionId" element={<ThinkingFlowPage />} />
      <Route path="/map/:sessionId" element={<DecisionMapPage />} />
      <Route path="/shared/:shareToken" element={<SharedDecisionPage />} />
      <Route path="/history" element={<HistoryPage />} />
      <Route path="/pricing" element={<PricingPage />} />
      <Route path="/payment/success" element={<PaymentSuccessPage />} />
      <Route path="/terms" element={<TermsPage />} />
      <Route path="/privacy" element={<PrivacyPage />} />
      <Route path="/refund" element={<RefundPage />} />
      <Route path="/contact" element={<ContactPage />} />
      <Route path="/enterprise" element={<EnterpriseDecisionPage />} />
      <Route path="/enterprise/analysis/:sessionId" element={<EnterpriseAnalysisPage />} />
      <Route path="/enterprise/history" element={<EnterpriseHistoryPage />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="min-h-screen bg-background font-body">
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
      <Toaster position="bottom-center" />
    </div>
  );
}

export default App;
